import { Controller } from "@hotwired/stimulus"

// A textarea that grows with what is written in it, so a draft is never
// clipped behind a scrollbar.
export default class extends Controller {
  connect() {
    this.grow()
  }

  grow() {
    this.element.style.height = "auto"

    // A field that is not on the screen yet - the footer's dialog before it is
    // opened - measures nothing at all. Its rows stand until it is shown, and
    // it grows from the first word written in it.
    const written = this.element.scrollHeight
    if (written === 0) return this.element.style.removeProperty("height")

    this.element.style.height = `${written}px`
  }
}
